<template>
  <wt-notifications-bar />
  <router-view :class="locale /* root element class to control fonts on each locale */" />
</template>

<script lang="ts" setup>
import { computed, onMounted, provide } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useUserinfoStore } from './modules/userinfo/stores/userinfoStore';

const store = useStore();

const darkMode = computed(() => store.getters['appearance/DARK_MODE']);
const { showUserNotifications } = useUserinfoStore();

provide('darkMode', darkMode);

const { locale, fallbackLocale } = useI18n();

const setLanguage = () => {
	const lang = localStorage.getItem('lang');
	if (lang) {
		locale.value = lang;
	}
	const fallbackLang = localStorage.getItem('fallbackLang');
	if (fallbackLang && fallbackLocale) {
		fallbackLocale.value = fallbackLang;
	}
};

onMounted(() => {
	setLanguage();
	showUserNotifications();
});
</script>

<style></style>
